<template>
  <svg width="30" height="14" viewBox="0 0 30 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.35" d="M0.5 2.75522C0.5 1.55861 1.47005 0.588554 2.66667 0.588554H24.1659C25.3625 0.588554 26.3325 1.5586 26.3325 2.75522V11.2447C26.3325 12.4413 25.3625 13.4114 24.1659 13.4114H2.66667C1.47005 13.4114 0.5 12.4413 0.5 11.2447V2.75522Z" stroke="#676767"/>
    <path opacity="0.4" d="M28.0522 4.56067V9.43931C29.0337 9.02612 29.672 8.06492 29.672 6.99999C29.672 5.93506 29.0337 4.97386 28.0522 4.56067Z" fill="#676767"/>
  </svg>
</template>

<script>
export default {
  name: 'Battery',
};
</script>
